import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { girisYapilmis, epostaAl } from '../services/authApi';

// Bu sayfalardaki fiyat/bakiye bilgisi artık sürekli canlı akmıyor; navbar'daki
// Yenile düğmesi yalnızca bu sayfalar açıkken görünür ve tıklandığında
// 'veri-yenile' event'ini yayınlar (bkz. takip-listem.jsx, alim-satim.jsx).
const YENILENEBILIR_YOLLAR = ['/takip-listem', '/alim-satim'];

function Navbar() {
  const [, setTick] = useState(0);
  const { pathname } = useLocation();

  useEffect(() => {
    function guncelle() {
      setTick(t => t + 1);
    }
    window.addEventListener('auth-changed', guncelle);
    window.addEventListener('storage', guncelle);
    return () => {
      window.removeEventListener('auth-changed', guncelle);
      window.removeEventListener('storage', guncelle);
    };
  }, []);

  const girisli = girisYapilmis();
  const yenilemeGosterilsin = YENILENEBILIR_YOLLAR.some(yol => pathname.startsWith(yol));

  return (
    <nav className="sticky top-0 z-50 w-full border-b border-slate-800 bg-slate-900 text-white shadow-sm">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <NavLink to="/" className="flex items-center gap-2 font-heading text-xl font-bold tracking-tight text-white hover:opacity-90 transition-opacity">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-sky-600">
            <span className="text-white font-bold leading-none">B</span>
          </div>
          Kaldır Yatırım Danışmanlık
        </NavLink>

        {girisli ? (
          <div className="flex items-center gap-4">
            <NavLink to="/takip-listem" className="text-sm font-medium text-slate-300 hover:text-white transition-colors" activeClassName="text-sky-400 hover:text-sky-400">Takip Listem</NavLink>
            <NavLink to="/alim-satim" className="text-sm font-medium text-slate-300 hover:text-white transition-colors" activeClassName="text-sky-400 hover:text-sky-400">Alım-Satım</NavLink>
            <NavLink to="/hesabim" className="text-sm font-medium text-slate-300 hover:text-white transition-colors" activeClassName="text-sky-400 hover:text-sky-400">Hesabım</NavLink>
            {yenilemeGosterilsin && (
              <button
                type="button"
                onClick={() => window.dispatchEvent(new Event('veri-yenile'))}
                title="Fiyat ve bakiye bilgilerini yenile"
                className="px-3 py-1.5 text-xs font-semibold rounded-lg border border-slate-700 text-slate-300 hover:text-white hover:border-slate-500 transition-colors"
              >Yenile</button>
            )}
            <span className="hidden sm:inline text-sm text-slate-400">{epostaAl()}</span>
            <NavLink to="/logout" className="text-sm font-medium text-slate-300 hover:text-red-400 transition-colors">Çıkış</NavLink>
          </div>
        ) : (
          <NavLink to="/login" className="text-sm font-medium text-slate-300 hover:text-white transition-colors">Giriş</NavLink>
        )}
      </div>
    </nav>
  );
}

export default Navbar
